import { domain } from "./auth";

export const EmployerUrl = domain + '/employers/v1';
export const POST_EMPLOYER_LIST = EmployerUrl + "/list";
export const PlanUrl = domain + '/plans/v1';
export const workshopUrl = domain + '/workshops/v1';
export const clientUrl = domain + '/clients/v1';

export const apiUrl = domain + '/users/v1';
export const apiUrl2 = domain + '/api/v1';
export const therapistUrl = domain + '/therapists/v1';
export const dashboardUrl = domain + '/dashboard/v1';
export const sessionUrl = domain + '/sessions/v1';

export const POST_LOGIN = apiUrl + "/login";
export const POST_OTP = apiUrl + "/verify-otp";
export const POST_RESEND_OTP = apiUrl + "/resend-otp";
export const POST_RESET_PASSWORD = apiUrl + "/reset-password";
export const POST_FORGOT_PASSWORD = apiUrl + '/forget-password';
export const POST_PROFILE_DETAILS = apiUrl + "/profile";
export const POST_PROFILE_UPDATE = apiUrl + "/update";
export const POST_COUNTRY_CODE = apiUrl2 + '/get-countries';
export const POST_STATE_CODE = apiUrl2 + '/get-states';
export const POST_CITY_CODE = apiUrl2 + '/get-cities';
export const POST_GENDER = apiUrl2 + '/get-genders';
export const POST_ISSUES = apiUrl2 + '/get-issues';
export const POST_LANGUAGE = apiUrl2 + '/get-languages';
export const POST_MHA_UPDATE = apiUrl + '/update-mental-health-assessment';
export const POST_THERAPIST_LIST = therapistUrl + '/best-therapist';
export const POST_ThERAPIST_DETAILS = therapistUrl + '/details';
export const POST_THERAPIST_SLOTS = therapistUrl + '/available-slots';
export const POST_USER_SUMMARY = dashboardUrl + '/user-summary';
export const POST_RATING_REMARKS = therapistUrl + '/change-therapist';
export const POST_RELATION_LIST = apiUrl2 + '/get-relations';
export const POST_REASONS_LIST = apiUrl2 + '/get-cancel-reason';

export const IS_ADMIN = apiUrl + "/admin-check";

export const GET_INDUSTRIES = apiUrl2 + "/get-industry";
export const GET_PLANTYPES = apiUrl2 + "/get-plans";
export const GET_THERAPYSESSION = apiUrl2 + "/get-session-type";
export const GET_WORKSHOPTYPE = apiUrl2 + "/get-workshop-type";
export const GET_SERVICES = apiUrl2 + "/get-servies";
export const GET_FILL_SERVICES = apiUrl2 + "/fill-services";
export const GET_GENDERS = apiUrl2 + "/get-genders";
export const GET_SUBSTATUS = apiUrl2 + "/get-status";
export const GET_SESSION_STATUS = apiUrl2 + "/get-session-status";

export const GET_ANALYTICS_DETAILS = EmployerUrl + "/dashboard"

export const POST_EMPLOYER_DETAILS = EmployerUrl + "/create";
export const GET_EMPLOYER_DETAILS = EmployerUrl + "/details";
export const UPDATE_EMPLOYER_DETAILS = EmployerUrl + "/update";
export const GET_EMPLOYER_HISTORY = EmployerUrl + "/history";
export const GET_EMPLOYER_NAMELIST = EmployerUrl + "/list-names";

export const POST_PLAN_LIST = PlanUrl + "/list";
export const POST_PLAN_DETAILS = PlanUrl + "/create";
export const GET_PLAN_DETAILS = PlanUrl + "/details";
export const UPDATE_PLAN_DETAILS = PlanUrl + "/edit";
export const GET_PLAN_HISTORY = PlanUrl + "/history";

export const POST_WORKSHOP_LIST = workshopUrl + "/list";
export const POST_WORKSHOP_DETAILS = workshopUrl + "/create";
export const GET_WORKSHOP_DETAILS = workshopUrl + "/details";
export const UPDATE_WORKSHOP_DETAILS = workshopUrl + "/update";
export const POST_WORKSHOP_CANCEL = workshopUrl + "/cancel";
export const GET_WORKSHOP_TYPE = workshopUrl + "/workshop-types";

export const POST_CLIENTS_LIST = clientUrl + "/list";
export const POST_CLIENTS_DETAILS = clientUrl + "/create";
export const GET_CLIENTS_DETAILS = clientUrl + "/details";
export const UPDATE_CLIENTS_DETAILS = clientUrl + "/update";
export const POST_BULK_UPLOAD = clientUrl + "/bulk-upload";
export const GET_BULK_UPLOAD_HISTORY = clientUrl + "/bulk-upload-history";
export const GET_UPLOAD_DATA = clientUrl + "/download-uploaded-data";
export const POST_TEMP_RESET_PWD = clientUrl + "/reset-temp-flag";
export const POST_RESET_MHA = clientUrl + "/reset-mha";
export const POST_DOWNLOAD_EMPLOYEE_LIST = clientUrl + "/download-employee-list";

export const GET_SESSION_LIST = sessionUrl + "/list";
export const DOWNLOAD_SESSION_REPORT = sessionUrl + "/download";